// extracted by css-extract-rspack-plugin
export default {"cls1":"OnboardingTour-cls1_pbO","cls2":"OnboardingTour-cls2_Vjl OnboardingTour-cls1_pbO"};